import React from "react";
import { Typography, Grid, Card, CardContent, Box, Button } from "@mui/material";
import "./forms-and-mettings.css";

const FormsAndMeetings = ({ nextStep, prevStep }) => {
  return (
    <Box className='forms-meeting-container'>
      <Box className='left-flower-character'>
        <img src='./CYPImages/WormisDonut.png' alt='left-flower character' className='left-flower-character-image' />
      </Box>
      <Box className='forms-container'>
        {/* Title */}
        <Typography variant='h4' className='forms-meet-title' align='center' gutterBottom>
          formS & MeetingS
        </Typography>

        {/* Grid of Cards */}
        <Grid container spacing={3} justifyContent='center'>
          {/* First Row */}
          <Grid item xs={12} sm={6}>
            <Card className='info-card' sx={{ backgroundColor: "#FEEABF" }}>
              <CardContent>
                <Typography variant='body1' align='center'>
                  To be able to care for you properly <br />
                  we need to know about you
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Card className='info-card' sx={{ backgroundColor: "#FEEABF" }}>
              <CardContent>
                <Typography variant='body1' align='center'>
                  We need to write information <br />
                  down so that it is not forgotten or lost.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Second Row */}
          <Grid item xs={12} sm={6}>
            <Card className='info-card' sx={{ backgroundColor: "#FEEABF" }}>
              <CardContent>
                <Typography variant='body1' align='center'>
                  Adults will write down things such as what you have done, what you have eaten and if you have taken
                  any medication alongside how your behavior has been.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Card className='info-card' sx={{ backgroundColor: "#FEEABF" }}>
              <CardContent>
                <Typography variant='body1' align='center'>
                  Your social worker will make a <br />
                  plan for your time in care, this is
                  <br /> called a care plan.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Third Row */}
          <Grid item xs={12} sm={6}>
            <Card className='info-card' sx={{ backgroundColor: "#FEEABF" }}>
              <CardContent>
                <Typography variant='body1' align='center'>
                  All young people who are looked <br />
                  after must have a care plan. A care <br />
                  plan is about you and providing you <br />
                  with help and support.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Card className='info-card' sx={{ backgroundColor: "#FEEABF" }}>
              <CardContent>
                <Typography variant='body1' align='center'>
                  We will also complete something <br />
                  called a placement plan. This will <br />
                  explain your routines, your likes
                  <br />
                  and dislikes, and any other <br />
                  important information an adult
                  <br /> caring for you would need to know.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid container justifyContent='space-between' alignItems='center' mt={2}>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={prevStep}>
              Previous
            </Button>
          </Grid>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={nextStep}>
              Next
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box className='bottom-forms' mr={3}>
        <img src='./CYPImages/WormisJaeinSpace.png' alt='Bottom Character' className='bottom-forms-image' />
      </Box>
    </Box>
  );
};

export default FormsAndMeetings;
